import React from "react";
import { ColorsData } from "../../../data/colors.data";

interface Props {
  car: any;
  color: any;
  setColor: (value: any) => void;
}

const SidebarColor: React.FC<Props> = ({ car, color, setColor}) => {
  
  const [colorList, setColorList] = React.useState<any>([]);

  React.useEffect(() => {
    if(car){
      const colorData: any = ColorsData();
      const colors = colorData[car.id] ;
      if(colors){
        const color_list: any = [];
        for (const color of colors) {
          if (color.active)
            color_list.push(color);
        }
        setColorList(color_list);
          setColor(color_list[0]);
      }
    }
  }, [car, setColor]);

  return (
    <div className="studio-sidebar-color">
      <div className="studio-sidebar-color-subcontainer">
        <div className='studio-sidebar-color-title'>Cambiar color</div>
        <div className='studio-sidebar-color-selection'>
          {
            (colorList as {}[]).map((colorItem: any, index: number) =>
              <div key={index} className={`studio-sidebar-color-element ${colorItem.id === color.id ? 'selected' : ''}`} onClick={() => {if(colorItem.interactable === true){setColor(colorItem)} }}>
                <img className={`studio-sidebar-color-img`} src={colorItem.icon} alt='' />
              </div>
            )
          }
        </div>
        {color && <div className='studio-sidebar-color-text'>{color.name}</div>}
      </div>
    </div>
  );
};

export default SidebarColor;